import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const PartsOfPanchangamPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `


    <h1>பஞ்சாங்கத்தின் அங்கங்கள் விபரமான தொகுப்பு</h1>
      <div class="color4">
        <div class="svk2">
      குறிப்பு:- 
      விஷயங்களின் ஆழத்தை உணர்த்தி ஆர்வத்தை ஏற்படுத்தும் முயற்சியாக யாமறிந்த வகையில் எளிமையாக சுருக்கமாக விவரிக்க முயற்சித்துள்ளோம். 
      மேலும் விபரமாக அறிய புத்தகங்களை வாங்கிப்படிக்கவும் அல்லது இணையதளங்களை பார்வையிடவும். பிழைகள் பொருத்தருளவும்். 
    </div></div>
    <div class="accordion">  
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">01-அறிமுகம் : </div>
</summary>
    <div class="sans">
      குறிப்பு:- பொதுவாக பஞ்சாங்கம் என்பது திதி, வாரம் (கிழமை), நக்ஷத்திரம், யோகம், கரணம் என்கிற ஒரு நாளின் ஐந்துவிதமான
      கால அளவுகளைப் பற்றி கூறும் நூல் ஆகையால் இதற்குப் பஞ்சாங்கம் அதாவது
      ஐந்து அங்கங்களைப் பற்றிக்கூறும் நூல் என்று பெயர் பெற்றது. கிழமை என்பது எந்த அளவுகோலும் இல்லாமல் பொழுது புலர்ந்தது
      முதல் அடுத்த பொழுது புலர்தலுக்கு முன் உள்ள நாளை ஒரு கிழமையின் பெயரால் ்குறிப்பிடுவது ஆகும்.
      <br> ஆனால் மற்ற நான்கு அங்கங்களும் அவ்வாறின்றி சூரியன், சந்திரன் ஆகிய கிரகங்களின் நகர்தலை ஒட்டி துல்லியமாக அளவிட்டு
      எடுத்து எழுதப்படும் கணக்கீடு ஆகும். இந்திய சாஸ்திரம் ஒன்று தவிர
      உலகின் வேறு எந்த இடத்திலும் காலங்களை கண்ணிமைக்கும் நேரத்தையும் துல்லியமாகக் கணக்கிட்டு நாட்காட்டி அமைத்துப்
      பயன்படுத்தும் வழக்கம் இருப்பதாகத் தெரியவில்லை.
      <br> இந்தப் பகுதியில் பஞ்சாங்கத்தின் பல்வேறு நுணுக்கமான கூறுகளையும் முடிந்தவரை சுருக்கமாக விவரித்து ஒரு புரிதலை
      ஏற்படுத்த முயற்சிக்கிறோம்.
      <br> மேலும் பஞ்சாங்கம் பற்றிய ஆழமான விஷயங்களை விவாதித்து அறிந்துகொள்ள www.brahminsnet.com/forums/forum.php என்கிற
      நமது இணைய தளத்திற்கு அடிக்கடி வருகை தரவும்.
    </div>
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">02-பஞ்சாங்கம் எனில்? </div>
</summary>
    <div class="sans">
      *பஞ்சாங்கம் என்றால் என்ன? **முக்கியமான பஞ்ச அங்கங்கள் பற்றி தெரிவிக்கும் நூல் என்பதால் பஞ்சாங்கம் என்று பெயர். பஞ்ச
      அங்கங்களாவன திதி, வாரம் (கிழமை), நக்ஷத்ரம், லக்னம், யோகம் அல்லது கரணம்.
  
  
      **ராசி மண்டல அமைப்பு:**மொத்தம் 12 ராசிகள் உள்ளன. மேஷம், ரிஷபம், மிதுனம், கடகம், சிம்மம், கன்னி, துலாம்,
      விருச்சிகம், தனுசு, மகரம், கும்பம், மீனம் என்பதாக.
  
      பூமி உருண்டையானது. அதை அட்சரேகை தீர்க்க ரேகை என்ற குறுக்கு மற்றும் நெடுக்குக் (கற்பனைக்) கோடுகளால் பிரிப்பது பற்றி
      அறிவோம். மொத்தம் 360 டிகிரி கொண்ட இந்த பூமியை 12 குறுக்கு கோடுகளால் சமபாகங்களாகப் பிரித்தால் ஒவ்வொரு பகுதிக்கும் 30
      டிகிரி வரும். ஒவ்வொரு ராசிக்கும் 30 டிகிரி என்பது இதனால் ஏற்படுகிறது.
  
  
      இந்த ராசிகளை வைத்து மாதம் எப்படி உருவாகிறது என்று பார்க்கலாம்.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">03-மாதம் உருவாதல்? </div>
</summary>
    <div class="sans">
      சூரியனின் கிரணங்கள் பூமியில் விழுகிறது. சூரியன் ஒரே இடத்தில்
      இருக்கிறது.
      பூமி தன்னைத்தானே சுற்றிக்கொள்கிறது.
      ஒரு முறை சுற்றிக்கொள்ள 24 மணி நேரம் ஆகிறது.
      அப்படிச் சுற்றி முடிக்கையில் அதிகாலையில்
      சூரியனுடைய முதல் கிரணம் எங்கே விழுகிறதோ அன்றைய
      முதல் ராசி அது என்று கொள்ளவேண்டும்.
      அருகில் தரப்பட்டுள்ள படத்தைப் பார்க்கவும். உருண்டையாக உள்ள பூமியை மேற்கிலிருந்து கிழக்காக 12 ஆக பிரித்து,
      வடக்கிலிருந்து தெற்காக
      12 ஆகப் பிரித்து கற்பனைக் கோடு போட்டுக்கொள்வோம்.
      பூமி சூரியனைச் சுற்றும் பாதையில் ஒரு நாளைக்கு ஒரு டிகிரிதான் நகர்கிறது,
      அதனால் அந்தத் த திசையில் (வடக்கு - தெற்காக ) வரையப்பட்டுள்ள ராசியைக் கடக்க 30 நாட்கள் ஆகிறது. ஒரு ராசி கடந்து
      அடுத்த ராசி வரும்போது அடுத்த மாதம் வருகிறது.
      உதாரணமாக நாம் பன்னிரண்டாகப் பிரித்து வைத்திருக்கும் மேஷராசிக்குரிய சித்திரை மாதத்தில் முதல் பாகையின் (பாகை –
      டிகிரி) முதல் அம்சத்தில்
      சூரியனுடைய கிரணம் விழுந்தால் அது சித்திரை மாதம் முதல் தேதி.
      ஆக சித்திரை மாதம் இப்படித் துவங்குகிறது.<br>
  
      இந்த பூமியானது சூரியனை ஒருமுறை சுற்றி வர 365 நாட்களாகிறது என்பது நம் எல்லோருக்கும் தெரியும். மொத்தம் 360 நாளில் 360
      டிகிரியைக் கடந்துவிடுகிறது.
      ஆக ஒரு நாளைக்கு ஒரு டிகிரி கடக்கிறது. <br> கிழக்கு மேற்காக தன்னைத்தானே சுற்றிக்கொள்வதால்தானே பகல் இரவு உண்டாகிறது?
      எனவே கிழக்கு மேற்காகச் சுற்றும்போது 360 டிகிரியை 24 மணிநேரத்தில் சுற்றி விடுகிறது. 12 ராசிக்கு 360 டிகிரி ஒரு
      ராசிக்கு 30 டிகிரி. எனவே ஒரு ராசியைக் கடக்க
      தோராயமாக 2 மணி நேரம். தினம்தோறும் வரும் ராசிகள் கர்மாக்களைச் செய்ய பயன்படுத்துவதால் இதை லக்னம் என்ற பெயரால்
      குறிப்பிடலாம். ஒவ்வொரு நாளும்
      பூமி சூரியப் பாதையில் ஒரு டிகிரி முன்னேறி விடுவதால் மாத ஆரம்பத்தில், சூரிய உதயத்தில் 2 மணி நேரம் இருந்த லக்ன
      இருப்பு, நாள் ஒன்றுக்கு தோராயமாக 4 நிமிடம் வீதம் குறைந்து
      30 நாளில் சூரிய உதயத்தின் போது அடுத்த லக்னம் சுமார் இரண்டு மணிநேர இருப்புடன் வந்து விடுகிறது. (அடுத்த மாதம்
      பிறந்துவிடுகிறது)
      <br>ஒரு நாளைக்கு 24 மணி நேரம் என்றால் பன்னிரண்டு ராசிக்கு தலா ரெண்டு மணிநேரம் என்பது சராசரிக் கணக்கு.
      ஆனால் துல்லியமாகச் சொன்னால் சில ராசிகளுக்கு சற்றுக் குறைவாகவும் சில ராசிகளுக்கு சற்று அதிகமாகவும் பஞ்சாங்கத்தின்
      மூலம் அறியலாம்.
      எந்தெந்த ராசிக்கு எவ்வளவு நேரம் என்பதை அடுத்த தலைப்பில் பார்க்கலாம்.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">04-ராசிக்கு கால அளவு </div>
</summary>
    <div class="sans">
      இதை “ராசிமானம்” என்றும் கூறுவர். இது சாயனப்படி தோராயமானது என்றாலும் வேறுபாடு என்பது மிகச் சொற்பமாகவே இருக்கும்.
      ஒவ்வொரு ராசியும் சமமாக இல்லாததற்குக் காரணம் மிகத் தெளிவானது. பூமி உருண்டையாக இருப்பதால் பூமியின் மையப் பகுதியில்
      இருக்கும் மிதுனம், கடகம், சிம்மம், கன்னி, துலாம், வ்ருச்சிகம் இவை அதிக கால அளவு உடையதாகவும் , இரு ஓரங்களிலும் உள்ள
      மேஷம், ரிஷபம், கும்பம், மீனம் ஆகிய ராசிகளின் கால அளவு குறைவாகவும் உள்ளது.
      <div class="sans">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ராசி
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">நாழிகை
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">மணி
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">மேஷம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">4.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">1.49
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">ரிஷபம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">4.45
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.02
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">மிதுனம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.11
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கடகம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.30
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.08
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">சிம்மம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.01
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கன்னி
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.0
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">1.59
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">துலாம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.0
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.10
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">வ்ருச்சிகம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.04
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">தனுசு
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.30
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">2.08
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">மகரம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">5.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">1.55
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">கும்பம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">4.45
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">1.43
            </td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">மீனம்
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">4.15
            </td>
            <td style="padding:8px; border:1px solid #e0e0e0">1.49
            </td>
          </tr>
        </table>
      </div>
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">05-ராசி இருப்பு ? </div>
</summary>
    <div class="sans">
      மாதம் உருவாவது எப்படி என்று தெரிந்து கொண்டதிலேயே ராசி இருப்பு என்ற பதத்தின் பொருளும் விளங்கும். கடக்க வேண்டிய மீதி
      ராசியே ராசி இருப்பு என்று சொல்கிறோம்.
      மேஷராசியின் முதல் பாகையை முதல் நாள் சூரியன் கடக்கிறது என்று பார்த்தோம்.
      இது தன்னைத்தானே சுற்றிக்கொள்வதால் கடக்கும் தூரம் அல்ல, மாறாக சூரியப் பாதையில் சுற்றுவதால் கடக்கும் தூரம் ஆகும் எனவே
      தன்தை்தானே சுற்றும்போது ஒரு டிகிரி கடக்க நான்கு நிமிடம் என்பது, இந்த சூரிய வட்டப் பாதையில் ஒரு டிகிரியைக் கடக்க ஒரு
      நாள் அல்லது 24 மணி நேரம் ஆகிறது என அறியவேண்டும்.
      அதே சமயம் லக்னப் பாதையில் ஒரு டிகிரி முன்னேற்றம் என்பது சுமார் 4 நிமிடம், ஒரு லக்னத்தின் 120 நிமிடத்தில்
      நாளொன்றுக்கு 4 நிமிடம் வீதம் குறைந்து அடுத்த நாள் அந்த லக்னத்தில்
      சூரிய உதயத்தின்போது எவ்வளவு நேரம் இருக்கிறது எனக் குறிக்கப்படுவதே ராசி இருப்பு ஆகும்.
      <br>
      உதாரணமாக இன்று ஆடி மாதம் பத்து தேதி என்று கொண்டால் கடகராசியில் (10x4=40) 40 நிமிடங்கள் போக மீதி 80 நிமிடங்கள் ராசி
      இருப்பு என்று சொல்லலாம்.
      நமது பரந்தாமன் பஞ்சாங்கத்தில் மட்டும் நாழிகை கணக்கில் இல்லாமல் மணியிலேயே ராசி இருப்பு போடப்பட்டிருக்கிறது.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">06-லக்னம் என்றால் ? </div>
</summary>
    <div class="sans">
      பூமிக்கு தன்னைத்தானே சுற்றுதல், சூரியனைச் சுற்றுதல் என இரண்டு விதமான நகர்வு உள்ளது அல்லவா?
      சூரியன் சித்திரை மாதத்தில் உதய நேரத்தில் மேஷ ராசியில் இருக்கிறான், அதுபோல்
      வைாகாசியில் உதய நேரத்தில் ரிஷப ராசியிலும்
      ஆனியில் உதய நேரத்தில் மிதுன ராசியிலும்
      ஆடியில் உதய நேரத்தில் கடக ராசியிலும்
      ஆவணியில் உதய நேரத்தில் சிம்ம ராசியிலும்
      புரட்டாசியில் உதய நேரத்தில் கன்னி ராசியிலும்
      ஐப்பசியில் உதய நேரத்தில் துலா ராசியிலும்
      கார்த்திகையில் உதய நேரத்தில் வ்ருச்சிக ராசியிலும்
      மார்கழியில் உதய நேரத்தில் தனுசு ராசியிலும்
      தை மாதத்தில் உதய நேரத்தில் மகர ராசியிலும்
      மாசி மாதத்தில் உதய நேரத்தில் கும்ப ராசியிலும்
      பங்குனியில் உதய நேரத்தில் மீன ராசியிலும் இருப்பான்.
      இந்த நிகழ்வு பூமி சூரியனைச் சுற்றுவதால் ஏற்படுகிறது <br>
      அதேபோல சித்திரை மாதத்தில் 1ம் தேதியன்று உதய நேரத்தில் மேஷத்தில் இருக்கும் சூரியன்
      பூமி சூரியனுக்கு எதிலில் நின்று தன்னைத்தானே சுற்றிக் கொள்வதால்
      வடக்குத் தெற்காக (கற்பனைக்) கோடு போட்டு கிழக்கு மேற்காக உண்டாக்கி வைத்திருக்கும் 12 ராசிகள்
      உள்ளன அல்லவா? அவற்றை சுமார் இரண்டு மணி நேரத்திற்கு ஒரு ராசியைக் கடந்து விடுகிறார் சூரியன்.
      (உண்மையில் சூரியன் அதே நிலையில் இருக்கிறார், பூமியின் சுழற்சியால் இரண்டு மணி நேரத்திற்கு
      ஒரு ராசி சூரியனை எதிர்கொள்கிறது.) இந்த ஒவ்வொரு நாளும் கிழக்கு மேற்கில் நகர்ந்து உருவாகும்
      ராசிகளே லக்கினங்கள் ஆகும்.
      சுருக்கமாகச் சொன்னால் - ஒரு தினத்தில் ஒரு குறிப்பிட்ட நேரத்தில் சூரியன் எந்த ராசியில் இருக்கிறாரோ அதுவே அந்த
      நேரத்துக்கான லக்கினமாகும்.
      மேலே கண்டுள்ளபடி, லக்கினங்களின் கால அளவுப்படி, சூரியன் அந்தக் குறிப்பிட்ட காலம் வரை, ஒவ்வொரு நாளும் ஒரு குறிப்பிட்ட
      நேரத்தில் இருப்பார்,
      அது அந்த நாளில் அந்த லக்கினம் ஆகும்.
  
      நாம் முஹூர்த்தத்திற்காக ‘லக்னம்’ என்று பார்க்கிறோம்.
      ஒவ்வொரு நாளும் 12 ராசிகள் வருகின்றன என்று பார்த்தோம். நாம் முஹூர்த்தத்துக்காக எந்த ராசியைத் தேர்ந்தெடுக்கின்றோமோ
      அதுவே லக்னம் எனப்படும்.
      மற்றபடி ராசிக்கும் லக்னத்துக்கும் எந்த வித்யாசமும் கிடையாது.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">07-ஸ்தான சுத்தம் ? </div>
</summary>
    <div class="sans">
      சில முஹூர்த்தங்களுக்காக எந்த ஸ்தானம் சுத்தமாக இருக்கவேண்டும் என்று சொல்லியிருக்கிறதோ லக்னத்திலிருந்து அந்த இடம் வரை
      எண்ணி
      அதில் ராகு, கேது, சனி, சுக்கிரன் என்று எந்த க்ரஹமும் இல்லாமல் இருப்பதே ஸ்தான சுத்தம் ஆகும்.
      தேர்ந்தெடுத்த லக்னமாகிய ராசி உட்பட ப்ரதக்ஷிணமாக எண்ணிவர குறிப்பிட்ட இடத்தில் எந்த க்ரஹமும் இல்லாதிருப்பது ஸ்தான
      சுத்தம் ஆகும்.
      உதாரணம்: விவாஹ லக்னத்திற்கு 7 வது ராசியில் எந்த க்ரஹமும் இருக்கக்கூடாது.
      ஸ்தான சுத்தம் அவசியம் பார்க்கவேண்டியவை: சாந்தி முஹூர்தத்தில் முஹூர்த்த லக்னமும், வித்யாரம்பத்திற்கு 4மிடமும், பயணம்
      புறப்பட 5மிடமும்,
      புதிது அணிய 6மிடமும், கல்யாணத்திற்கு 7மிடமும், உபநயன/பும்ஸவன/சீமந்தத்திற்கு 8மிடமும், சௌளத்திற்கு 9மிடமும், அன்ன
      ப்ராசனத்திற்கு 10மிடமும்,
      க்ருஹப்ரவேசத்திற்கு 12மிடமும் சுத்தம் அவசியம்.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">08- க்ரஹபாதசாரம் </div>
</summary>
    <div class="sans">
  
      **கிரகங்களின் இடமாற்றம்:**அடுத்து கிரகங்களின் இடமாற்றம் பற்றித் தெரிந்து கொள்வோம்.
      பஞ்சாங்கங்களில் உள்ள மாதாந்திர ராசிக் கட்டத்தில் சந்திரன் தவிர மற்ற அனைத்துக் க்ரஹங்களையும் போட்டிருப்பார்கள்.
      புதன், சுக்ரன், செவ்வாய் ஆகிய க்ரஹங்களும் ஒரு மாதத்திற்குள் வீடு மாறிவிடுவார்கள். அவர்கள் மாறும் தேதியை
      ராசிக்கட்டத்தின் மையத்தில் உள்ள கட்டத்தில் குறிப்பிடுவது வழக்கம்.
      எனவே மாதத்தின் முதல் தேதியில் க்ரஹங்கள் உள்ள நிலைக்கு வரையப்பட்ட ராசிக் கட்டத்தில் உள்ளபடியே மாதம் முழுவதும்
      கட்டங்கள் காலியாக இருக்கும் என்று எண்ணாமல்,
      நாம் பார்க்கும் தேதிக்கு க்ரஹங்கள் மாறுதல் அடைந்துள்ளனவா என்பதற்கும் அன்றைய தேதியில் சந்திரன் எங்கிருக்கிறான்
      என்பதையும் பார்த்து ஸ்தான சுத்தத்தைத் தீர்மானிக்கவேண்டும்.
      பூமியைப் போலவே 9 கிரகங்கள் உண்டு என்று நாம் அறிவோம். பூமி சூரியனைச் சுற்றுவது போலவே அவைகளும் அவைகளுக்குரிய
      பாதையில், அவைகளுக்குரிய வேகத்தில் சுற்றி வருகின்றன.
      சந்திரன் பூமியைச் சுற்றி வருகின்றது என்பதையும் நாம் அறிவோம். இந்த நிலையை பஞ்சாங்கத்தில் அந்தந்த மாதத்தின்
      பக்கத்திலேயே கட்டத்தில் போட்டிருப்பார்கள்.
      மாத ஆரம்ப நாள் அன்று எந்த கிரகம் எந்த ராசியில் இருக்கிறது என்று போட்டிருப்பார்கள். சனி, ராகு, கேது போன்ற கிரகங்கள்
      சீக்கிரமாக ராசி மாறாது.
      ஆனால் சுக்ரன், புதன், செவ்வாய் போன்ற கிரகங்கள் வேகமாக மாறும். சில சமயம் மாதம் ரெண்டு முறை கூட மாறும். அந்த
      மாற்றத்தை எந்த தேதியில் எந்த ராசிக்கு மாறுகிறது என்று கட்டத்தின் நடுவிலேயே கொடுத்திருப்பார்கள்.
      இப்படி கிரகங்களின் இடமாற்றம் பற்றிக் குறிப்பிட்டவர்கள் சந்திரனின் இட மாற்றத்தைப்பற்றி மட்டும் எங்கும்
      குறிப்பிட்டிருக்க மாட்டார்கள்.
      காரணம் சந்திரனின் இடமாற்றம் என்பது அபரிமிதமானது. இரண்டரை நாளுக்கு ஒருமுறையாக ராசி மாறிவிடுவார் அவர்.
      அவரின் இட மாற்றத்தை குறிப்பது கடினம் என்பதாலேயே பஞ்சாங்கத்தில் குறிப்பிடுவதில்லை. ஆனால் அவர் இருக்குமிடத்தை நாம்
      தெரிந்து கொள்ள முடியும்.
      அதற்கு நட்சத்திரங்களைப் பற்றித் தெரிந்துகொள்ளவேண்டும்..
      **நட்சத்திரங்கள் பற்றிய அறிவு:**
      சந்திரனுக்கும் நட்சத்திரங்களுக்கும் என்ன தொடர்பு என்று கேட்டால் கணவன் மனைவிக்குள்ள தொடர்புதான். சந்திரனுக்கு 27
      நட்சத்திரங்களை மணமுடித்து வைத்திருக்கிறார்கள் என்று கதை உண்டு.
      அதனால் அன்றைய நாள் என்ன நட்சத்திரமோ அதுவே சந்திரன் இருக்கும் இடம் என்று தெரிந்து கொள்ளலாம். இனி நட்சத்திரம் பற்றிப்
      பார்ப்போம்.
  
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">09-நக்ஷத்திரமும் ராசியும்? </div>
</summary>
    <div class="sans">
      ஒவ்வொரு ராசிக்கும் 30 டிகிரி என்று பார்த்தோம். அந்த 30 டிகிரியை ஒன்பது பாதங்களாகப் பிரித்துவிடவேண்டும்.
      அப்படிப்பிரிக்கப்பட்ட ஒன்பதில் ஒரு பாதத்துக்கு (1/9) நவாம்சம் என்று பெயர்.
      அதாவது அஸ்வினி என்று எடுத்துக்கொண்டால் 1 2 3 4 பாதங்கள் உண்டு. பரணிக்கும் அப்படியே 1 2 3 4 பாதங்கள் உண்டு. அடுத்து
      கிருத்திகைக்கும் அப்படியே உண்டு.
      அதில் முதல் பாதம் மட்டும் எடுத்துக்கொண்டு மேஷ ராசிக்கு அஸ்வினி 4 பாதங்கள், பரணி 4 பாதங்கள், கிருத்திகை ஒரு பாதம்
      மொத்தம் 9 பாதங்கள், அதாவது ரெண்டேகால் நட்சத்திரம் மேஷராசிக்கு என்று கொள்ளவேண்டும்.
      கிருத்திகை 2 3 4 பாதங்கள், ரோகிணி 1 2 3 4 பாதங்கள், மிருகசிரீஷம் 1, 2 பாதங்கள் ஆக 9 பாதங்கள், ரெண்டேகால்
      நட்சத்திரம் ரிஷப ராசிக்கு.
      மேலும் கீழே அட்டவணையில் உள்ளது போல பார்த்துக்கொள்ளவும்.
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            பூரட்-4th, <br>உத்ட்- all<br>ரேவ- all<br>மீனம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">அசு-all பர- all க்ரு- 1<br>மேஷம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">க்ரு-2,3,4 ரோ- all ம்ருக-1,2 <br>ரிஷபம்<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">ம்ருக-3,4
            திஆ - all
            புன -1,2,3 <br> மிதுனம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            அவி -3,4
            சத - all
            பூரட் - 1,2,3
            <br>கும்பம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0"></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            புன -4th
            பூச- all
            ஆயி- all
            <br>கடகம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            உத்ரா - 2,3,4
            திஓ-all
            அவி -1,2
            <br>மகரம்<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0"></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            மகம்-all
            பூரம்-all
            உத்ரம்-1st
            <br>சிம்மம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            மூல- all
            பூராட -all
            உத்ராட – 1st
            <br>தனுசு<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            விசா - 4th
            அநு - all
            கேட்- all
            <br>வ்ருச்சி<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            சித்தி -3&4
            ஸ்வாதி - all
            விசா-1,2,3
            <br>துலா<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            உத்ர-2,3,4
            ஹஸ்த -all
            சித்தி-1,2
            <br>கன்னி<br></td>
        </tr>
      </table>
  
      சில நட்சத்திரங்கள் (அஸ்வினி, பரணி போன்றவை) கட்டாயம் மேஷராசியில்தான் வரும். கிருத்திகை என்றால் முதல் பாதம் மட்டும்
      மேஷத்திலும் மீதி மூன்று பாதங்களானால் ரிஷபத்திலும் வரும்.
      ஆகையால் ஒருவரது நட்சத்திரமும் அதன் பாதமும் தெரிந்துவிட்டால் அவரது ராசியைக் கண்டுபிடித்துவிடலாம். பஞ்சாங்கத்தில்
      அன்றைய நட்சத்திரமும் போட்டிருக்கும் என்பதால் அதை அறிவதும் சுலபம்.
      பாம்பு பஞ்சாங்கம் என்றால் கடைசியில் சந்திரன் எந்த ராசியில் இருப்பார் என்றும் போட்டிருப்பார்கள்.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">10-நவாம்சம் என்றால்? </div>
</summary>
    <div class="sans">
      ஒவ்வொரு நக்ஷத்திரத்திற்கும் 4 பாதங்கள் உள்ளன. இதனால் மொத்தம் உள்ள 27 நக்ஷஷத்திரத்திற்கும் 27 x 4 = 108 பாதங்கள்.
      இதனால் ஒரு பாதத்திற்கு 3.33 டிகிரி வரும்.
      ஒரு ராசி என்பது மொத்தம் உள்ள 360 டிகிரியில் 12ல் ஒரு பாகம் அதாவது 30 டிகிரி ஆகும். இந்த ராசியையே மேலும் 9
      கூறுகளாகப் பகுத்தால் ஒரு ராசி கட்டத்தில் ஒரே ஒரு பாதம் மட்டுமே இருக்கும்.
      எனவே இப்படி ஒரு ராசியில் 9ல் ஒரு பாகம் என்பதால் இதற்கு நவாம்சம் என்று பெயர். <br>
      கீழுள்ள கட்டத்தைப் பார்க்கவும். ஒரு கட்டத்திற்கு ஒரு நக்ஷத்திரத்தின் ஒரு பாதம் மட்டுமே போடப்பட்டுள்ளது. அதே
      நக்ஷத்திரத்தின் அடுத்த பாதம் அடுத்த ராசியில் போடப்பட்டுள்ளது,
      இப்படியாக அஸ்விநி முதல் கார்த்திகை வரை உள்ள 3 நக்ஷத்திரங்களின் 12 பாதங்கள் 12 கட்டங்களில் போடப்பட்ட பின், மீண்டும்
      ரோகிணியின் 1ம் பாதம் மேஷத்தில் ஆரம்பிக்கும்
  
  
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            கார்- 4ம் பாதம்<br>மீனம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">அசு-1ம் பாதம்<br>மேஷம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0">அசு -2ம் பாதம் <br>ரிஷபம்<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">அசு- 3ம் பாதம் <br> மிதுனம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            கார்- 3ம் பாதம்
            <br>கும்பம்</td>
          <td style="padding:8px; border:1px solid #e0e0e0"></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            அசு- 4ம் பாதம்
            <br>கடகம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            கார் - 2ம் பாதம்
            <br>மகரம்<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0"></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            பர - 1ம் பாதம்
            <br>சிம்மம்<br></td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">
            கார் - 1ம் பாதம்
            <br>தனுசு<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            பர - 4ம் பாதம்
            <br>வ்ருச்சி<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            பர - 3ம் பாதம்
            <br>துலா<br></td>
          <td style="padding:8px; border:1px solid #e0e0e0">
            பர - 2ம் பாதம்
            <br>கன்னி<br></td>
        </tr>
      </table>
      <hr class="orange">
      ரோகிணி, ம்ருகசீருஷம், திருவாதிரை - 2வது சுற்று
     
            <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ரோகி-1 </td>
                <td style="padding:8px; border:1px solid #e0e0e0"> மேஷ</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ரோகி-2 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">ரிஷ</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ரோகி-3 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">மிது</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ரோகி-4 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">கட</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ம்ருக-1 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">சிம்ம</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ம்ருக-2 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">கன்னி</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ம்ருக-3 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">துலா</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">ம்ருக-4 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">வ்ருச்</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">திருவா-1 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">தனுசு</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">திருவா-2 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">மகர</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">திருவா-3 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">கும்ப</td>
              </tr>
              <tr style="border-bottom:1px solid #ccc">
                <td style="padding:8px; border:1px solid #e0e0e0">திருவா-4 </td>
                <td style="padding:8px; border:1px solid #e0e0e0">மீன</td>
              </tr>
            </table>
        
      <hr class="orange">
      புனர்பூசம், பூசம், ஆயில்யம் - 3வது சுற்று
      <hr class="orange">
      மகம், பூரம், உத்ரம் - 4வது சுற்று
      <hr class="orange">
      ஹஸ்தம், சித்திரை, ஸ்வாதி - 5வது சுற்று
      <hr class="orange">
      விசாகம், அநுஷம், கேட்டை - 6வது சுற்று
      <hr class="orange">
      மூலம், பூராடம், உத்ராடம் - 7வது சுற்று
      <hr class="orange">
      திருவோணம், அவிட்டம், சதயம் - 8வது சுற்று
      <hr class="orange">
      பூரட்டாதி, உத்ரட்டாதி, ரேவதி - 9வது சுற்று
      <hr class="orange">
      சுற்று ஒன்றுக்கு 12 ராசிக்கு 12 நவாம்சங்கள் வீதம், 9 சுற்றில் 108 நவாம்சங்கள் பூர்த்தியாகும்
      <hr class="orange">
      இதை நன்றாகத் தெரிந்துகொண்டால் க்ரஹபாதசாரம் - க்ரஹங்களின் நகர்வை பஞ்சாங்கங்களில்
      இந்த நவாம்சையில்தான் குறிப்பார்கள், அறிந்து கொள்ள சுலபமாக இருக்கும்.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">11-விலக்கவேண்டியவை? </div>
</summary>
    <div class="sans">
      பொதுவாக ஆகாத நாட்களை விலக்குதல்:-
  
  
      இனி பொதுவாக ஆகாத நாட்களை பார்ப்போம். கிழமைகளில் ஞாயிறு - திங்கள் ஒரு கண்ணுள்ள நாளாகவும் , புதன்- வியாழன்- வெள்ளி
      இரு கண்ணுள்ள நாட்களாகவும்,
      செவ்வாய் மற்றும் சனி குருட்டு நாளாகவும் ஆன்றோர் கருதுவதால் குருட்டு நாட்களில் காரியங்களை தவிர்த்து முடிந்தவரை இரு
      கண்ணுள்ள நாட்களிலும்
      தவிர்க்க முடியாதபோது ஒரு கண்ணுள்ள நாளையும்; தேர்ந்தெடுப்போம்.
      மற்றபடி வளர் பிறை நாட்கள் தேய் பிறை நாட்களைக் காட்டிலும் சிறந்தது. த்யாஜ்யம் என்பது ஒரு குறிப்பிட்ட காலத்தின் வலிமை
      குன்றிய பகுதி அல்லது நன்மையற்ற பகுதி.
      திதி, வாரம், நக்ஷத்திரம், லக்னம், மாதம் ஆகிய அனைத்திற்கும் த்யாஜ்யம் உண்டு. மாதத் த்யாஜ்யமே கரிநாளாகும். மற்ற காலப்
      பகுதிகளில் நாம் த்யாஜ்யம் பார்ப்பதை வழக்கத்தில் கொள்ளாதது போலவே
      மாதத் த்யாஜ்யமான கரிநாளையும் கருதத் தேவையில்லை என்பது பெரும்பாலோர் கருத்து.
  
      அமாவாசை, ப்ரதமை, அஷ்டமி, நவமி, பெளர்ணமி இவை சுப காரியங்களுக்கு பொருந்தாத திதிகள்.
      சதுர்த்தி, ஏகாதசி, சதுர்த்தசி ஆகியவை மத்திமமான திதிகள்.
      த்விதியை, த்ருதியை, பஞ்சமி, ஸப்தமி, தசமி, த்வாதசி, த்ரையோதசி இவை மிக உத்தமமான திதிகள்.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">12-பொருத்தம் என்றால்? </div>
</summary>
    <div class="sans">
      <h2>சுலபமான தினப்பொருத்த அட்டவணை</h2>
      <div class="sans">
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">No</td>
            <td style="padding:8px; border:1px solid #e0e0e0">தன் நக்ஷத்ரம்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பொருந்தும் நக்ஷத்ரங்கள்</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">1</td>
            <td style="padding:8px; border:1px solid #e0e0e0">அசு, மக, மூல</td>
            <td style="padding:8px; border:1px solid #e0e0e0">2,4,6,8,9</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">2</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பர, பூர, பூராட</td>
            <td style="padding:8px; border:1px solid #e0e0e0">1,3,5,7,9</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">3</td>
            <td style="padding:8px; border:1px solid #e0e0e0">கா,உத்,உத்ரா</td>
            <td style="padding:8px; border:1px solid #e0e0e0">1,2,4,6,8</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">4</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ரோ,ஹஸ்,திஓ</td>
            <td style="padding:8px; border:1px solid #e0e0e0">2,3,5,7,9</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">5</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ம்ரு,சித்,அவி</td>
            <td style="padding:8px; border:1px solid #e0e0e0">1,3,4,6,8</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">6</td>
            <td style="padding:8px; border:1px solid #e0e0e0">திவா,ஸ்வா,சத</td>
            <td style="padding:8px; border:1px solid #e0e0e0">2,4,5,7,9</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">7</td>
            <td style="padding:8px; border:1px solid #e0e0e0">புன,விசா,பூரட்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">1,3,5,6,8</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">8</td>
            <td style="padding:8px; border:1px solid #e0e0e0">பூச,அநு,உத்ட்</td>
            <td style="padding:8px; border:1px solid #e0e0e0">2,4,6,7,9</td>
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">9</td>
            <td style="padding:8px; border:1px solid #e0e0e0">ஆயி,கேட்,ரேவ</td>
            <td style="padding:8px; border:1px solid #e0e0e0">1,3,5,7,8</td>
          </tr>
        </table>
      </div>
      <div class="svk">
        இது நமது பஞ்சாங்கத்தின் மிக உன்னதமான கண்டுபிடிப்பு.
        <hr class="orange">
        சற்று கவனமாகப் பார்த்து புரிந்துகொண்டால் மிக மிக எளிமையானது.
        <hr class="orange">
        அவரவர் செட் எண்களை மட்டும் மனதில் இறுத்திக்கொண்டால், எந்த நாளும்
        நமக்குப் பொருந்துமா என்பதை ஒரு நொடியில் அறியலாம்.
      </div>
      பட்டியலில் முதல் கலத்தில் No. என்கிற தலைப்பின் கீழ் உள்ள எண்கள் செட் எண்கள் ஆகும்.
      <hr class="orange">
      2ம் கலத்தில் அந்தந்த எண்ணுக்குரிய நக்ஷத்திரங்கள் தரப்பட்டுள்ளன.
      <hr class="orange">
      2ம் கலத்தில் உள்ள நக்ஷத்திரத்தைச் சேர்ந்தவர்களுக்கு பொருத்தமான
      நக்ஷத்திரங்களின் செட் எண்கள் 3ம் கலத்தில் தரப்பட்டுள்ளன.
      <hr class="orange">
      உதாரணம் : - <br>
      அஸ்விநி, மகம், மூலம் ஆகிய 3 நக்ஷத்திரங்களுக்கும்
      2, 4, 6, 8, 9 ஆகிய செட்களைச் சேர்ந்த 2- பரணி, பூரம், பூராடம், 4-ரோஹிணி, ஹஸ்தம், திருவோணம்,
      6-திருவாதிரை, ஸ்வாதி, சதயம், 8-பூசம், அநுஷம், உத்திரட்டாதி, 9-ஆயில்யம், கேட்டை, ரேவதி ஆகிய 15 நக்ஷத்திரங்களும்
      தினப் பொருத்தம் உள்ளவை என்று பொருள்.
      <hr class="orange">
      இதில் பரணி, பூரம், பூராடம், திருவாதிரை, ஆயில்யம், கேட்டை ஆகிய 6 நக்ஷத்திரங்களும் சுபம் செய்ய பொருத்தமற்றவை ஆதலால்
      மற்ற 9 நாட்களில் சுப செய்துகொள்ளவேண்டும்.
      <hr class="orange">
      <div class="svk">
        இதுபோலவே மற்ற செட்காரர்களும் தங்களுக்குறிய சுபம் செய்ய உத்தமம் மற்றும்
        மத்திம பலனுள்ள தினப்பொருத்தம் உள்ள நக்ஷத்திரங்களைத்
        தெரிந்து வைத்துக்கொண்டு சுபங்களைச் செய்யவேண்டும்.</div>
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">13-பொருத்தம் யாருக்கு?</div>
</summary>
    <div class="sans">
  
      உபநயனத்தில் மட்டும் உபநயனப் பையனுக்கும், <br>
      ஸீமந்தம், க்ருஹப்ரவேசம், கல்யாணம் ஆகிய அனைத்திலும் பெண்ணுக்கும் தினப் பொருத்தம் பார்க்கவேண்டும். <br>
      சூசகமாகத் தெரிந்துகொள்ள - ஆயுஷ்ய ஹோமம், ஷஷ்டியப்த பூர்த்தி போன்ற ஒரு குறிப்பிட்டவரை உத்தேசித்துச் செய்யப்படும்
      சுபங்கள் தவிர, பெண் - ஆண் இருவருக்கும் (தம்பதிகளுக்கு) சேரந்து பொதுவாகச் செய்யும் எந்த சுப காரியத்திலும்,
      பெண் சம்பந்தப்பட்டால், பெண்ணின் நக்ஷத்திரத்திற்குத்தான் பொருத்தம் பார்க்கவேண்டும்.<br>
      யாருக்கும் சந்திராஷ்டமம் கூடாது. தினப் பொருத்தம் தவிர வேறு எதற்கும் முஹூர்த்தம் பண்ணுகிறவர்களுடைய நக்ஷத்திரம்
      போன்றவை பயனில்லை.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">14-சந்த்ராஷ்டமம் என்றால்? </div>
</summary>
    <div class="sans">
      சந்திராஷ்டமம் என்றால் என்ன?இந்த வார்த்தையில் சந்திரன், அஷ்டமம் என்று ரெண்டு பதங்கள் உள்ளன. நாம் பிறந்த
      ராசியிலிருந்து எட்டாம் ராசியில் சந்திரன் இருக்கும் நாட்கள் எல்லாம் சந்திராஷ்டமம் எனப்படும். இந்த நாட்களில்
      (சிக்கல்கள், மனத்தாங்கல்கள் போன்ற) விபரீதமாகப் பலன்கள் இருக்கும் என்பதால் அதை விலக்குவது. விவாஹத்துக்கு லக்னம்
      வைக்கும்போது ஆணுக்கும், பெண்ணுக்கும் சந்திராஷ்டமம் இல்லாத நாட்களையே தேர்ந்தெடுக்கவேண்டும்.
  
      இதை எப்படிக் கண்டறிவது என்றால் அவரவர் நட்சத்திரத்திலிருந்து 17ம் நட்சத்திரம் என்றைக்கோ அன்றைக்கே சந்திராஷ்டமம்
      என்று கீழே உள்ள அட்டவணையைப் பார்த்து அறியலாம்.
      
      <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">அஸ்விநி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">அநுஷம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">பரணி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">கேட்டை
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கார்த்திகை
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">மூலம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ரோகிணி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">பூராடம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ம்ருகசீர்ஷம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ராடம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">திருவாதிரை
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">திருவோணம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">புனர்பூசம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">அவிட்டம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">பூசம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">சதயம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ஆயில்யம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">பூரட்டாதி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">மகம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ரட்டாதி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">பூரம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ரேவதி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ரம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">அஸ்விநி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ஹஸ்தம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">பரணி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சித்திரை
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">கார்த்திகை
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ஸ்வாதி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ரோகிணி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">விசாகம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ம்ருகசீர்ஷம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">அநுஷம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">திருவாதிரை
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">கேட்டை
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">புனர்பூசம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">மூலம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">பூசம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">பூராடம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஆயில்யம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ராடம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">மகம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">திருவோணம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">பூரம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">அவிட்டம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ரம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">சதயம்
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஹஸ்தம்
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">பூரட்டாதி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">சித்திரை
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">உத்ரட்டாதி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">ஸ்வாதி
          </td>
        </tr>
        <tr style="border-bottom:1px solid #ccc">
          <td style="padding:8px; border:1px solid #e0e0e0">ரேவதி
          </td>
          <td style="padding:8px; border:1px solid #e0e0e0">விசாகம்
          </td>
        </tr>
  
      </table>
      
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">15-சூரிய உதய பயன்? </div>
</summary>
    <div class="sans">
      அடுத்து சூரிய உதயத்தின் பயன் என்ன என்று பார்க்கலாம்.
  
  
      சூர்யோதயம் எதற்காகத் தெரிந்துகொள்வது?
      பஞ்சாங்கங்களில் ஒவ்வொரு தேதியிலும் இன்ன நட்சத்திரம் இவ்வளவு நாழி இருக்கும், இன்ன திதி இவ்வளவு நாழி இருக்கும் என்று
      குறிப்பிடப்பட்டிருக்கும். பரந்தாமன் பஞ்சாங்கத்தில் ஆங்கில மணியிலும், மற்ற பஞ்சாங்கங்களில் நாழிகைக் கணக்கிலும்
      குறிப்பிட்டிருப்பார்கள். அது அன்றைய சூரிய உதயத்திலிருந்து இவ்வளவு நாழி அல்லது மணி இருப்பதாகப்
      புரிந்துகொள்ளவேண்டும்.
  
  
      சூரியோதயம் என்பது ஏப்ரல் மே மாதங்களில் கிட்டத்தட்ட ஆறு மணியாக இருக்கும். பின்னால் செல்லச்செல்ல, மார்கழி போன்ற
      மாதங்களில் பார்த்தால் கிட்டத்தட்ட 6.40 என்பதாகத் தள்ளிச்சென்றுவிடும். இப்போது மார்கழி மாதத்தில் ஒரு வியாழனன்று காலை
      7. 45 க்கு முஹூர்த்தம் வைத்துக்கொள்கிறோம் (அன்று 6 – 7.30 a.m..யமகண்டம்) என்றால் அந்த மாதம் சூர்யோதயம் 6.40 என்றால்
      நாம் வைக்கும் முஹூர்த்தம் யமகண்டமாக ஆகிவிடும். இது போன்றவைகளைத் தவிர்க்கவே சூர்யோதயத்தைத் தெரிந்துகொள்வது.
  
  
      இது நாட்டுக்கு நாடு மாறும். ஒரே ரேகையில் இருக்கும் நாடுகளில் பெரிதாக மாறுதல்கள் இருக்காது. ஆனால் கிழக்கு மேற்காக
      இருக்கும் நாடுகளில் வித்யாசம் இருக்கும். அதனால் அதைக் கவனத்தில் கொண்டு நாம் நேரத்தைக் குறிக்கவேண்டும்.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">16-நாழியை மணியாக்க? </div>
</summary>
    <div class="sans">
      <h2>நாழியை மணியாக மாற்றுவது எப்படி?</h2>
      அடுத்ததாக நாழிகையை மணியாக மாற்றுவது எப்படி என்று பார்க்கலாம்.
      நாழிகை – மணி:
      ஒரு நாளைக்கு 24 மணிநேரம் என்பது எல்லோருக்கும் தெரியும். ஆனால் முன்காலத்தில் நாழிகைக் கணக்கில் இருக்கும்போது ஒரு
      நாளைக்கு 60 நாழிகையாக வைத்திருந்தனர். இது ரெண்டும் ஒன்றுதான்.
      ஒரு மணி நேரத்துக்கு 60 நிமிடங்கள். நாழிகைக் கணக்கில் பார்த்தால் ஒரு நாழிகைக்கு 60 விநாழிகை என்று அளவு. இதை அறிவது
      மிகவும் சுலபம்.
  
  
      ஒரு மணி நேரத்துக்கு 2 1/2 நாழிகை. ஒரு நாழிகைக்கு 24 நிமிடங்கள். So, 2.5 x 24 = 60 நிமிடங்கள். இதற்கு சுலபமான ஒரு
      formula இருக்கிறது.
  
  
      ஒரு நாழிகைக்கு ரெண்டரை விநாழிகை. ஒரு நிமிடத்தை விநாழிகையாக மாற்றவேண்டும் என்றால் அதை ரெண்டரையால் பெருக்கிவிடலாம்.
      அதாவது 1 x 2.5 = 2.5 விநாழிகை.
  
  
      அதே போல விநாழிகையை மணியாக மாற்ற அதை 0.4 வால் பெருக்கிவிடவேண்டும். அதாவது பத்து விநாழிகையை மணியாக மாற்ற 10 x 0.4 = 4
      நிமிடங்கள் என்று கொள்ளவும்.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">17-கௌரி பஞ்சாங்கம்  </div>
</summary>
    <div class="sans">
      <h2>கௌரி பஞ்சாங்கம் என்றால் என்ன?</h2>
      கௌரி பஞ்சாங்கம் என்று எல்லோரும் கேள்விபட்டிருப்போம். அப்படின்னா என்ன?
  
  
      சிலருக்கு பஞ்சாங்கத்தைப் புரிந்து கொள்ள, நாள் பார்க்க எல்லாம் சிரமமாக இருக்கும். ஒவ்வொரு பஞ்சாங்கத்திலும்
      (ஸ்ரீரங்கம் பஞ்சாங்கம் என்றால் 29 பக்கத்திலும் பரந்தாமன் பஞ்சாங்கத்தில் 20 ம் பக்கத்திலும் பார்க்கலாம்) கௌரி
      பஞ்சாங்கம் என்று, இன்னின்ன கிழமைகளில் பகல் இரவு வேளைகளுக்கு என்று ஒவ்வொரு ஒண்ணரை மணிநேரத்துக்கும் ஒரு பலன்
      கொடுத்திருப்பார்கள் (கீழே படத்தில் உள்ளபடி). சுப, லாப, சோர, உத்யோக, ரோக என்று பலன்கள் இருக்கும். அதில்
      தவிர்க்கவேண்டியவைகளை தவிர்த்து சுப வேளைகளில் முஹூர்த்தம் வைக்கலாம்.
  
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">18-ஜன்ம-அநுஜன்மாதி ?</div>
</summary>
    <div class="sans">
      <h2>ஜன்ம-அநுஜன்ம-த்ரிஜன்மம் -என்ன?</h2>
      அடுத்து ஜன்ம, அனுஜன்ம, த்ரிஜன்மங்கள்:ஒவ்வொரு நட்சத்திரத்துக்கும் பத்தாவது நட்சத்திரம் அனுஜன்மமாகும். 19 வது
      நட்சத்திரம் திரிஜன்மமாகும். அதாவது அஸ்வினி, மகம், மூலம் மூன்றும் ஜன்ம, அனுஜன்ம, திரிஜன்மங்களாம். இவைகளின் குணங்கள்
      ஒன்றாக இருக்கும். பலன்கள் ஒன்றுபோலவே இருக்கும். முதல் பர்யாயம், ரெண்டாம் பர்யாயம், மூன்றாம் பர்யாயாம் என்றும்
      சொல்லுவதுண்டு. அதற்கேற்ப நாள் பார்க்கலாம். இதன் வரிசை:
  
      அஸ்வினி – மகம் – மூலம்
      <hr class="orange">
      பரணி – பூரம் – பூராடம்
      <hr class="orange">
      கார்த்திகை - உத்திரம் - உத்திராடம்
      <hr class="orange">
      ரோகிணி – ஹஸ்தம் – திருவோணம்
      <hr class="orange">
      மிருகசிரீஷம் – சித்திரை – அவிட்டம்
      <hr class="orange">
      திருவாதிரை – சுவாதி – சதயம்
      <hr class="orange">
      புனர்பூசம் – விசாகம் – பூரட்டாதி
      <hr class="orange">
      பூசம் – அனுஷம் – உத்திரட்டாதி
      <hr class="orange">
      ஆயில்யம் – கேட்டை – ரேவதி
      <hr class="orange">
  
  
      இப்படி ஜன்ம அனுஜன்ம திரிஜன்ம நட்சத்திரங்களைத் தெரிந்துகொள்ளலாம்.
      <hr class="orange">
      இதைத் தெரிந்துகொண்டால், சில விஷயங்கை இந்த ஜன்ம த்ரயங்களில்
      செய்யலாம் என்றும், சில விஷயங்களைச் செய்யக்கூடாது என்றும்
      வரையறுக்கப்பட்டுள்ளதை அறிந்து அதன்படி செய்யலாம்.
      <hr class="orange">
      ஜன்ம த்ரையங்களில் -- ஆயுராதி ஹோமங்கள், வியாபாரம் துவங்குதல்,
      புது நகை அணிதல், சாந்தி கர்மாக்கள், க்ரஹப்ரவேசம், பெண்ணுடைய ஜன்ம
      நக்ஷத்திரத்தில் திருமணம் இவை செய்யலாம்.
      <hr class="orange">
      உபநயனம், ருது ஸங்கமம், ஸீமந்தம், ஆணுக்குத் திருமணம், ஊனம் - மஹாளயம்
      போன்ற அவகாசம் உள்ள ஶ்ராத்தங்கள் இவை பண்ணக்கூடாது.
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">19-அக்னிநக்ஷத்ர தோஷம்? </div>
</summary>
    <div class="sans">
      <h2>அக்னிநக்ஷத்திரத்தில் கூடாதவை?</h2>
      அடுத்து அக்னி நட்சத்திர காலத்தைப் பற்றி:
  
      அக்னி நட்சத்திரம்:இந்த காலம் வசந்த காலத்தில் வருகிறது.
      மிகவும் நல்ல காலம்.
      <hr class="orange">
      இந்தக் காலத்தில் சுப காரியங்களை விலக்கவேண்டும் என்று புரளிகள் உண்டு.
      ஆனால் உண்மை அப்படியல்ல.
      <hr class="orange">
      க்ருஹ்ய சூத்ரத்தில் தக்ஷிணாயன காலத்தை விட
      உத்தராயண காலமே சிறந்தது, அதில் சுப காரியங்கள்
      செய்ய வேண்டும் என்று சொல்லப்பட்டிருக்கிறது.
      <hr class="orange">
  
      அக்னி நட்சத்திர காலத்தில் செய்யத் தகுந்தவை
  
      விவாஹம், உபநயனம், பூச்சூட்டல், கிரகப்பிரவேசம், ருதுசாந்தி.
      <hr class="orange">
      செய்யத் தகாதவை:
  
      குளம், கிணறு வைப்பது, தோட்டம் வைப்பது, மரம் நடுதல் ஆகியவை.
      <hr class="orange">
    </div>
  
    </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">20-ஶ்ராத்த திதி பற்றி?</div>
</summary>
    <div class="sans">
      <h2>ஶ்ராத்தம் - ஶ்ராத்த திதி பற்றி?</h2>
      இனி ஶ்ராத்த திதிகள் பற்றி:
      ஶ்ராத்த திதிகளை எப்படித் தெரிந்து கொள்வது என்று பார்க்கலாம்.
      <hr class="orange">
      பஞ்சாங்கத்தில் ஒவ்வொரு நாளும் இன்னின்ன தேதியில்
      இன்னின்ன நாழி வரை இன்னின்ன திதி என்பதாக
      ஒரு திதி போடப்பட்டிருக்கும்.
      அது அந்நாளின் ஶ்ராத்த திதியாக இருக்க வேண்டிய அவசியமில்லை.
      குதப காலத்தில் என்ன திதியோ அதுவே ஶ்ராத்த திதியாகும்.
      <hr class="orange">
      அதாவது பிராமணர்களுக்கு தினமும் ஐந்து வித யக்ஞங்கள்
      விதிக்கப்பட்டிருக்கின்றன.
      <hr class="orange">
      தினமும் பெருமாள் திருவாராதனம் செய்வது தேவ யக்ஞம்,
      <hr class="orange">
      அடுத்து வேத அத்யயனம் (அத்யயனம் என்றால் வேதத்தை அறிவது,
      இந்நாளில் வேதாத்யயனம் என்ற இடத்தில்
      ஏதோ ஒரு ருத்ரம், சமகம், புருஷசூக்தத்தையாவது அனுசந்திக்கவேண்டும்)
      செய்வது பிரம்ம யக்ஞம்,
      <hr class="orange">
      மூன்றாவது பூத யக்ஞம்...நம்மைப் போல மற்ற ஜீவராசிகளுக்கு
      உணவிடுவது, இந்நாளில் காக்கைக்கு உணவிடுவது இந்த வகையில் வரும்.
      <hr class="orange">
      (நம் முன்னோர்களே காக்கையாக வருகிறார்கள் என்பதெல்லாம் உண்மையில்லை).
      <hr class="orange">
      இந்த வரிசையில் நாலாவதாக வருவது பித்ருயக்ஞம் என்கிற பித்ரு தர்ப்பண ஶ்ராத்தாதிகள்.
      <hr class="orange">
      இதற்கு குதப காலத்தில் மத்யானம் ரெண்டு ரெண்டரைக்கு மேல் நாலு மணிக்குள் செய்யவேண்டும்
      என்று விதிக்கிறது தர்ம சாஸ்திரம்.
      அந்த நேரத்தில் என்ன திதியோ அதுவே ஶ்ராத்த திதியாகும்.
      <hr class="orange">
  
  
      ஶ்ராத்தம் என்றால் என்ன? ஏன் பண்ணுகிறோம்?
      நம்மை விட உயர்ந்தவர்களின் தாட்சண்யம் வேண்டும்
      என்பதற்காக தாழ்ந்த நிலையில் இருப்பவர்கள் அவர்களுக்கு ஒரு உணவோ,
      பானமோ தந்து உபசரிப்பது போல பிராமணனாகப் பிறந்தவர்கள்
      பித்ருக்களுக்கு செய்யும் ஒரு ப்ரீதியே ஶ்ராத்தம் என்று சொல்லலாம்.
      <hr class="orange">
  
      தாழ்ந்த நிலையில் இருப்பவனுக்கு உயர்ந்த நிலையில் இருப்பவனின் தயவு,
      தாட்சண்யம் வேண்டும், அதற்காக செய்யப்படும் காரியம்தான்
      அவனை ரட்சிக்கிறது என்று சொல்ல முடியாது.
      <hr class="orange">
      அதுபோல நாம் இடும் உணவுதான் பித்ருக்களை ரட்சிக்கிறது
      என்றும் சொல்லமுடியாது.
      <hr class="orange">
  
      அதேபோல, ஒரு பிராமணனுக்கு இடும் உணவு எப்படி பித்ரு
      லோகத்தில் உள்ள பித்ருக்களுக்கு போய்ச் சேரும் என்று விஞ்ஞான
      பூர்வமாயும் விளக்க முடியாது.
      அப்படி இருந்தால் வெளியூருக்குச் சென்றவனை நினைத்து
      வேறு ஒருவனுக்கு உணவிட்டால் வெளியூர் சென்றவன் வயிறு நிரம்பணுமே...
      அதனால் மந்திர பூர்வமாக பித்ருக்களின் கவனத்தை நம் பக்கம் ஈர்த்து
      அவர்களின் பரிவு, ப்ரீத்தியை சம்பாதிப்பதே ஶ்ராத்தத்தின்
      நோக்கு என்று தெரிந்து கொள்வோம்.
      <hr class="orange">
  
      இதைத் தெரிந்துகொள்ள சில விஷயங்களைத்
      தெரிந்து கொள்ள வேண்டும்.
      இந்த பூமிப் பரப்பில் பல ஆன்மாக்கள் பரந்துள்ளன.
      பூமியில் மனித, பிராணி, ஸ்தாவரங்கள் என்று மூவகை
      உயிரினங்கள் உள்ளன. அவைகள் சதா தம் இனப்பெருக்கத்தில்
      ஈடுபட்டுக்கொண்டிருக்கின்றன. இந்த ஆன்மாக்கள் பூமி பரப்பிலேயே
      இருந்தால் அப்படிப் பட்ட ஒரு இனப்பெருக்க சம்பவத்தில் புகுந்து
      மறுபடி இங்கேயே பிறக்கும். ஆனால் மறுபிறவி வேண்டாம்
      என்று நினைக்கும் பிராமணர்கள் அந்த ஆன்மாக்களை
      அடுத்த நிலைக்கு தூக்கிவிடக் கூடிய காரியம்தான் ஶ்ராத்தமாகும்.
      <hr class="orange">
  
      பித்ருக்கள் வசு, ருத்ர, ஆதித்ய ரூபங்களில் இருப்பர்.
      <hr class="orange">
      நாம் ஒரு ஆன்மாவை உயரத் தூக்கி விடும்போது பித்ருக்களும்
      நம் மேல் கொண்ட பரிவால் அங்கிருந்து ஆன்மாக்களை
      இழுத்துக் கொள்கிறார்கள்.
      <hr class="orange">
      அதாவது ஒரு Tug of Warல் இழுத்தவன்
      அதே இடத்தில் நில்லாமல் சற்றுத் தள்ளி
      நிற்பதுபோல வசுக்கள், ருத்ரர்களாகவும்,
      ருத்ரர்கள் ஆதித்யர்களாகவும், ஆதித்யர்கள்
      சுவர்க்கம் போகத்தகுதி பெறவும் என்பதாக
      அடுத்த நிலையை அடைய ஸ்ரார்தங்கள் உதவும்.
      இவையெல்லாம் பிராமணர்களுக்கு உள்ள பொது விதிகள்.
      <hr class="orange">
      வைஷ்ணவர்களுக்கு வேறு concept உண்டு.
      <hr class="orange">
  
  
      பெருமாள் நமக்கு ஒத்தாசை பண்ணுவார்.
      தேவதைகள் நமக்கு ஒத்தாசை பண்ணுவா.
      ஆனா அதெல்லாம் அவர்களை ஸ்தோத்திரம் செய்பவர்களுக்கு,
      சாஸ்திரம் விதித்தபடி அவர்களுக்கென்று ஏற்பட்டிருக்கும் சோம,
      அஸ்வமேத யக்ஞங்களை ஸ்ரத்தையாக செய்பவர்களுக்குத்தான்
      ஒத்தாசை பண்ணுவா. ஆனா பித்ருக்கள் அப்படியில்லை.
      நாம் சாதாரணமாக சாதத்தைத் தந்தாலே
      அதை நினைவு வைத்துக்கொண்டு நமக்கு
      உபகாரம் பண்ணுவார்கள் பித்ருக்கள்.
      <hr class="orange">
      தேவதைகள் பொதுவாக எல்லோருக்கும் உபகாரம் பண்ணுபவர்கள்
      பித்ருக்களோ நமக்காக பெர்சனலாக உபகாரம் பண்ணுமவர்கள்.
      <hr class="orange">
      இதனால் பல தேவதைகளை உபாசித்துப் பெறும் பலன்களை
      பித்ருக்களை உபாசித்தே பெறலாம் என்று ஏற்படுகிறது.
      பாவம், புண்ணியம் – என்ன அர்த்தம்?
      <hr class="orange">
      ச்லோகார்த்தேந
      ப்ரவக்ஷயாமி யதுக்தம் க்ரந்த கோடீஷு
      <hr class="orange">
      பரோபகார: புண்யாய பாபாய பரபீடநம்"
      <hr class="orange">
  
      என்று ஒரு ஸ்லோகம் உண்டு.
      <hr class="orange">
      இதன் பொருள்: கோடிக்கணக்கான கிரந்தங்களில்
      சொல்லப்பட்டிருப்பதை அரை ஸ்லோகத்தால் சொல்கிறேன் என்கிறார்.
      <hr class="orange">
      அப்படி என்ன சொல்லப் போகிறார் என்றால்
      தன்னலத்துக்காக இல்லாமல், பிறர் நலத்துக்காக
      என்ன காரியமெல்லாம் செய்கிறோமோ, அவை புண்யங்கள்.
      <hr class="orange">
      பிறத்தியாரை உபத்ரவித்து, ஹிம்சித்து பண்ணும் காரியங்கள்
      எல்லாம் பாபங்கள்.
      <hr class="orange">
      இந்த பாப புண்ணியங்களின் காரியம் என்ன என்றால் மேலே
      சொன்னதுபோல ஆன்மாக்களை மேலே எழும்ப விடாமல்
      பூமியை நோக்கி இழுப்பது பாபங்களின் வேலை.
      அப்படி இழுக்க விடாமல் தடுக்கும் தடைகளை போக்கி மேலே
      இழுக்க உதவுவது புண்ணியங்களின் வேலை.
      <hr class="orange">
      பிராமணர்களின் சிறப்பு:இந்த பாப புண்ணியங்கள்தான் உலகத்தையே
      ஆட்டிவிக்கின்றன. பாவங்கள் எப்படி வரும்? என்றால்
      நம் உடல் இச்சையைத் தீர்த்துக்கொள்ள அதமமான காரியங்களில்
      ஈடுபடுவதும், நாம் நன்றாக சௌக்கியமாக
      இருக்கவேண்டும் என்பதற்காக பொருள் ஆசையால்,
      பொருளை சேர்ப்பதற்காக அதர்ம காரியங்களைச் செய்வது
      என்ற இந்த ரெண்டு காரியம்தான் எல்லா பாபங்களுக்கும்
      அடிப்படையா இருக்கும். புண்ணியம் பண்ண தர்மத்தை
      போஷிப்பதுதான் வழி.
      <hr class="orange">
  
  
      இப்படி சம்பாதித்த பாபங்களை ரெண்டு வழியால் போக்கிக்கலாம்.
      ஒன்று ஜபதபங்கள், உபவாசம், தீர்த்தயாத்திரை போல
      உடல் வருத்தி செய்யும் காரியங்கள் மூலமாகப் போக்கிக்கலாம்.
      இன்னொன்று சாஸ்திரத்தில் சொல்லப்பட்டிருக்கும் எத்தனையோ
      வகை தானங்களை பிராமணர்களுக்கு அளிப்பதன் மூலம் போக்கிக்கலாம்.
      <hr class="orange">
  
      எல்லோர் உடம்பிலும் சிவப்பு ரத்தம்தானே ஓடுகிறது?
      எதற்கு பிராமணனுக்கு என்று தனியாக சொல்லியிருக்கு என்றால்
      பிறரிடம் தானம் பெற்று அவர்களின் பாபத்தையும் போக்கி,
      தன்னையும் பாபமற்றவனாகச் செய்துகொள்ளத்தான் வேதாத்யயணம்
      போன்றவைகளை சாஸ்திரம் பிராம்மணனுக்கு விதிக்கிறது.
      அதற்கான காரியம்தான் சந்த்யாவந்தனங்கள்.
      <hr class="orange">
  
  
      முன் தின இரவில் செய்த பாபத்தை பிராதர்சந்த்யையில்
      ‘சூர்யஸ்ச்ச மாமன்யுஸ்ச’ என்றும் பகலில் பண்ண பாவங்களை
      ‘அக்னிஸ்ச்ச மாமன்யுஸ்ச’ என்றும் மந்திரங்கள்
      சொல்லி போக்கிக்கொள்கிறான். மாத்யாஹ்நிகத்தில்
      பஞ்சமாபாதகம், உபபாதகங்களைப் போக்கிக் கொள்கிறான்.
      <hr class="orange">
  
      அதனால் பிராம்மணர்கள் அனைவரும் சந்த்யாவந்தனாதிகளைத்
      தப்பாமல் செய்ய வேண்டும்.பஞ்சாங்க தானம்:மேலே சொன்ன
      அனுஷ்டானங்களை பண்ண பஞ்சாங்க நூல் மிகவும்
      உதவும் என்பதால் எல்லா தானங்களிலும் பஞ்சாங்க தானம் உயர்ந்தது.
  
    </div>
</details>
    </div>
  
` }} />
    </div>
  );
};

export default PartsOfPanchangamPage;
